import ClearIcon from '@mui/icons-material/Clear';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import {
  Button,
  Container,
  Modal,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { saveFinding } from '../../redux/reducers/findingsReducer';

function ResolveFindingModal({ handleClose, finding }) {
  const initialResolutionDetails = { notes: '' };
  const [resolutionDetails, setResolutionDetails] = useState(initialResolutionDetails);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    const newDetails = { ...resolutionDetails };
    newDetails[name] = value;
    setResolutionDetails(newDetails);
  };

  const handleInitialize = () => {
    setResolutionDetails({ ...initialResolutionDetails });
  };

  const handleCancel = () => {
    handleInitialize();
    handleClose();
  };

  const handleSave = () => {
    dispatch(saveFinding({
      ...finding,
      notes: resolutionDetails.notes,
      resolved: true,
    }));
    handleClose();
  };

  const handleBackdropClick = () => false;

  return (
    <Modal open onClose={() => handleBackdropClick()}>
      <Container variant="modal" disableGutters sx={{ width: '600px' }}>
        <Stack variant="modalTop" spacing={2}>
          <Typography variant="h6">
            {t('finding.modal.markResolved')}
          </Typography>
          <Stack spacing={3}>
            <Typography>{t('finding.modal.resolveDescription')}</Typography>
            <TextField
              variant="outlined"
              subtype="signinField"
              onChange={handleChange}
              name="notes"
              value={resolutionDetails.notes}
              multiline
              rows="6"
              InputLabelProps={{
                shrink: true,
              }}
              label={t('finding.modal.notes')}
              required
            />
          </Stack>
        </Stack>
        <Stack variant="modalButtons" direction="row" justifyContent="flex-end" spacing={1}>
          <Button variant="text" startIcon={<ClearIcon />} onClick={() => handleCancel()}>
            <Typography variant="button">
              {t('finding.modal.cancel')}
            </Typography>
          </Button>
          <Button
            variant="contained"
            disabled={!resolutionDetails.notes}
            startIcon={<SaveRoundedIcon />}
            onClick={() => handleSave()}
          >
            <Typography variant="button">
              {t('finding.modal.resolveButton')}
            </Typography>
          </Button>
        </Stack>
      </Container>
    </Modal>
  );
}

export default ResolveFindingModal;
